import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrimbleCaptureResponseComponent } from './trimble-capture-response.component';

import { PayStudentComponent } from './pay-student.component';
import { PaylayoutComponent } from './paylayout.component';




const routes: Routes = [
  {
      path: '', component: PaylayoutComponent,
      children: [


          { path: 'trimbleCaptureResponse', component: TrimbleCaptureResponseComponent }

      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrimbleFeePaymentRoutingModule { }
